import { render, staticRenderFns } from "./PreviewVoucher.vue?vue&type=template&id=2bdb8e20&scoped=true&"
import script from "./PreviewVoucher.vue?vue&type=script&lang=js&"
export * from "./PreviewVoucher.vue?vue&type=script&lang=js&"
import style0 from "./PreviewVoucher.vue?vue&type=style&index=0&id=2bdb8e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb8e20",
  null
  
)

export default component.exports